import { createInertiaApp } from '@inertiajs/vue3'
import { createApp, h } from 'vue'
import { setCurrentLocale } from './translations.js'

createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  // title: title => title ? `${title} - App` : 'App',

  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.vue', {
      eager: true,
    })
    return pages[`../pages/${name}.vue`]

    // To use a default layout, import the Layout component
    // and use the following lines.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    // const page = pages[`../pages/${name}.vue`]
    // page.default.layout = page.default.layout || Layout
    // return page
  },

  setup({ el, App, props, plugin }) {
    // Initialize locale from server-side props
    if (props.initialPage?.props?.locale?.current) {
      setCurrentLocale(props.initialPage.props.locale.current)
    }
    
    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
    
    // Also make page props globally available for translation fallback
    if (typeof window !== 'undefined') {
      window.page = props.initialPage
    }
    
    app.mount(el)
  },

  // Update global locale on page changes
  onSuccess: (page) => {
    if (page?.props?.locale?.current) {
      setCurrentLocale(page.props.locale.current)
    }
    if (typeof window !== 'undefined') {
      window.page = page
    }
  }
})
